var _excluded = ["disabled", "type"],
    _excluded2 = ["className", "classNameInput", "small", "value", "hideLabel", "disableRemoveButon", "onRemove"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import cx from "classnames";
import "./inputEmail.scss";

var InputEmail = function InputEmail(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      props = _objectWithoutProperties(_ref, _excluded);

  var className = props.className,
      classNameInput = props.classNameInput,
      small = props.small,
      value = props.value,
      _props$hideLabel = props.hideLabel,
      hideLabel = _props$hideLabel === void 0 ? false : _props$hideLabel,
      _props$disableRemoveB = props.disableRemoveButon,
      disableRemoveButon = _props$disableRemoveB === void 0 ? true : _props$disableRemoveB,
      onRemove = props.onRemove,
      otherInputProps = _objectWithoutProperties(props, _excluded2);

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isEmailValid = _React$useState2[0],
      setIsEmailValid = _React$useState2[1];

  var validateEmail = function validateEmail(email) {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  };

  React.useEffect(function () {
    if (value) setIsEmailValid(!!validateEmail(value));
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx("cntInputEmail", !isEmailValid && "cntInputEmail__error", className && className)
  }, !hideLabel && /*#__PURE__*/React.createElement("label", {
    className: cx("cntInputEmail_label")
  }, "Email"), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10 emailDiv"
  }, /*#__PURE__*/React.createElement("input", _extends({}, otherInputProps, {
    value: value || "",
    className: cx("cntInputEmail_field", classNameInput && classNameInput),
    type: "email",
    disabled: disabled
  }))), !disableRemoveButon && /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-block",
    onClick: onRemove
  }, "-"))), !isEmailValid && /*#__PURE__*/React.createElement("p", {
    className: cx("cntInputEmail_error")
  }, "El email es incorrecto"));
};

export default InputEmail;